/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sub_Downgrade_DescriptionInputs */



/**
* | output |
* | --- |
* | "Changes take effect at the end of your billing period ({date}). You keep Team features until then." |
*
* @param {Sub_Downgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_downgrade_description = /** @type {((inputs: Sub_Downgrade_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Downgrade_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Änderungen treten am Ende Ihres Abrechnungszeitraums in Kraft (${i?.date}). Sie behalten Team-Funktionen bis dahin.`)
	return /** @type {LocalizedString} */ (`Changes take effect at the end of your billing period (${i?.date}). You keep Team features until then.`)
});